import DraggableContext from 'ui/src/components/draggable/context'
import { Container, Dnd, Gradient } from './style'

type Props = {
    className?: string
    hsv: number[]
    onChange?: (hsv: number[]) => void
}

const ColorPickerValue = ({ className, hsv, onChange }: Props) => {
    const [hue = 0, saturation = 1, value = 1] = hsv

    return (
        <DraggableContext>
            <Container className={className} style={{ backgroundColor: `hsl(${hue}, 100%, 50%)` }}>
                <Gradient />
                <Dnd hue={hue} saturation={saturation} value={value} onChange={onChange} />
            </Container>
        </DraggableContext>
    )
}

export default ColorPickerValue
